import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { LuTarget } from "react-icons/lu";
import { FiPackage } from "react-icons/fi";
import { useNavigate, useParams } from "react-router-dom";
import useCommissionStructure from "./hooks/useCommissionStructure";
import { Autocomplete, Button, TextField } from "@mui/material";
import { Modal } from "react-bootstrap";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";

const UpdateCommissionStructure = () => {
  const { data, method } = useCommissionStructure();
  const { id } = useParams();
  const {
    formData,
    teamMember,
    serviceList,
    groupModal,
    groupForm,
    groupList,
    error,
    groupMode,
    spinner,
  } = data;
  const {
    handleChange,
    handleCloseGroupModal,
    handleGrpupChange,
    handleStaffToggle,
    commissionUpdateApi,
    handleRemoveItem,
    handleAddItem,
    handleItemChange,
    handleTierChange,
    handleRemoveTier,
    handleAddTier,
    handleModelType,
    handleAssignTo,
    handleGroupSubmit,
    handleOpenEditGroupModal,
    handleOpenAddGroupModal,
    commissionGroupDelte,
    commissionDetailsData,
    setError,
  } = method;
  const navigate = useNavigate();

  const currencySymbol = "₹";

  useEffect(() => {
    if (id) {
      commissionDetailsData(id);
    }
  }, [id]);

  const handleUpdate = () => {
    commissionUpdateApi(id);
  };

    const allowOnlyNumberAndDot = (e) => {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
    "Tab",
  ];

  if (allowedKeys.includes(e.key)) return;

  // Allow digits and dot only
  if (!/^[0-9.]$/.test(e.key)) {
    e.preventDefault();
  }

  // Prevent multiple dots
  if (e.key === "." && e.target.value.includes(".")) {
    e.preventDefault();
  }
};

  return (
    <div>
      <ToastContainer />
      <section>
        {spinner && <div>Loading...</div>}
        <div className="m-t-3 cus-padd cusheight">
          <header>
            <div className="d-flex flex-column flex-md-row justify-content-between">
              <h2 className="page-tittle mb-2 mb-md-0">
                <i
                  className="fa-solid fa-angle-left cusgap cursor me-2"
                  onClick={() => navigate(-1)}
                ></i>
                Edit Commission Structure
              </h2>
            </div>
            <hr />
          </header>
          <div>
            <div>
              <div className="container-fluid">
                {/* Basic Information Section */}
                <div
                  className="card mb-4"
                  style={{
                    border: "none",
                    borderRadius: "12px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  }}
                >
                  <div className="card-body p-4">
                    <div className="d-flex align-items-center mb-4 gap-1">
                      <FiPackage color="#EA8F80" />
                      <h5
                        className="mb-0"
                        style={{
                          color: "#333",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Basic Information
                      </h5>
                    </div>

                    {/* Structure Name */}
                    <div className="mb-3">
                      <label
                        className="form-label"
                        style={{
                          fontSize: "14px",
                          color: "#555",
                          fontWeight: "500",
                        }}
                      >
                        Structure Name{" "}
                        <span style={{ color: "#DC3545" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="e.g., Senior Stylist Commission"
                        name="structureName"
                        value={formData.structureName}
                        onChange={handleChange}
                        style={{
                          borderColor: "#DDD",
                          borderRadius: "8px",
                          padding: "10px 14px",
                          fontSize: "14px",
                        }}
                      />
                      {error.structureName && (
                        <p className="text-danger mt-1 small">
                          {error.structureName}
                        </p>
                      )}
                    </div>

                    {/* Validity Period */}
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          style={{
                            fontSize: "14px",
                            color: "#555",
                            fontWeight: "500",
                          }}
                        >
                          Valid From{" "}
                          <span style={{ color: "#999" }}>(Optional)</span>
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          placeholder="dd-mm-yyyy"
                          name="validFrom"
                          value={formData.validFrom}
                          onChange={handleChange}
                          style={{
                            borderColor: "#DDD",
                            borderRadius: "8px",
                            padding: "10px 14px",
                            fontSize: "14px",
                          }}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          style={{
                            fontSize: "14px",
                            color: "#555",
                            fontWeight: "500",
                          }}
                        >
                          Valid To{" "}
                          <span style={{ color: "#999" }}>(Optional)</span>
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          placeholder="dd-mm-yyyy"
                          name="validTo"
                          value={formData.validTo}
                          onChange={handleChange}
                          style={{
                            borderColor: "#DDD",
                            borderRadius: "8px",
                            padding: "10px 14px",
                            fontSize: "14px",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Assignment Section */}
                <div
                  className="card mb-4"
                  style={{
                    border: "none",
                    borderRadius: "12px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  }}
                >
                  <div className="card-body p-4">
                    <div className="d-flex align-items-center mb-4">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#EA8F80"
                        strokeWidth="2"
                        className="me-2"
                      >
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      </svg>
                      <h5
                        className="mb-0"
                        style={{
                          color: "#333",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Assignment
                      </h5>
                    </div>

                    {/* Assign To */}
                    <div className="mb-3">
                      <label
                        className="form-label"
                        style={{
                          fontSize: "14px",
                          color: "#555",
                          fontWeight: "500",
                        }}
                      >
                        Assign To
                      </label>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <button
                            onClick={() => handleAssignTo("GROUP")}
                            className="w-100 py-3"
                            style={{
                              border:
                                formData.assignTo === "GROUP"
                                  ? "2px solid #EA8F80"
                                  : "2px solid #E0E0E0",
                              backgroundColor:
                                formData.assignTo === "GROUP"
                                  ? "#FFF5F0"
                                  : "#FFF",
                              color:
                                formData.assignTo === "GROUP"
                                  ? "#EA8F80"
                                  : "#666",
                              borderRadius: "8px",
                              cursor: "pointer",
                              transition: "all 0.2s",
                            }}
                          >
                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              style={{ margin: "0 auto 0px", display: "block" }}
                            >
                              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                              <circle cx="9" cy="7" r="4" />
                              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                            </svg>
                            <div
                              style={{ fontSize: "14px", fontWeight: "500" }}
                            >
                              Group
                            </div>
                          </button>
                        </div>
                        <div className="col-md-6">
                          <button
                            onClick={() => handleAssignTo("STAFF")}
                            className="w-100 py-3"
                            style={{
                              border:
                                formData.assignTo === "STAFF"
                                  ? "2px solid #EA8F80"
                                  : "2px solid #E0E0E0",
                              backgroundColor:
                                formData.assignTo === "STAFF"
                                  ? "#FFF5F0"
                                  : "#FFF",
                              color:
                                formData.assignTo === "STAFF"
                                  ? "#EA8F80"
                                  : "#666",
                              borderRadius: "8px",
                              cursor: "pointer",
                              transition: "all 0.2s",
                            }}
                          >
                            <LuTarget />
                            <div
                              style={{ fontSize: "14px", fontWeight: "500" }}
                            >
                              Team Member
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Select Group or Team Member */}
                    {formData.assignTo === "GROUP" ? (
                      <div>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <label
                            className="form-label mb-0"
                            style={{
                              fontSize: "14px",
                              color: "#555",
                              fontWeight: "500",
                            }}
                          >
                            Select Group{" "}
                            <span style={{ color: "#DC3545" }}>*</span>
                          </label>
                          <button
                            onClick={handleOpenAddGroupModal}
                            type="button"
                            style={{
                              color: "#EA8F80",
                              fontSize: "14px",
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                              fontWeight: "500",
                            }}
                          >
                            + Create New Group
                          </button>
                        </div>
                        <select
                          onChange={handleChange}
                          name="groupId"
                          value={formData.groupId || ""}
                          className="form-select"
                          style={{
                            borderColor: "#DDD",
                            borderRadius: "8px",
                            padding: "10px 14px",
                            fontSize: "14px",
                          }}
                        >
                          <option value="">Select a group</option>
                          {groupList.map((group) => (
                            <option key={group._id} value={group._id}>
                              {group?.groupName}
                            </option>
                          ))}
                        </select>
                        {error.groupId && (
                          <p className="text-danger mt-1 small">
                            {error.groupId}
                          </p>
                        )}
                        {/* Manage Groups */}
                        <div className="mt-4">
                          <h6
                            style={{
                              fontSize: "14px",
                              color: "#555",
                              fontWeight: "500",
                              marginBottom: "12px",
                            }}
                          >
                            Manage Groups
                          </h6>
                          <div
                            className="space-y-2"
                            style={{ maxHeight: "280px", overflow: "auto" }}
                          >
                            {groupList.map((group) => (
                              <div
                                key={group._id}
                                className="d-flex justify-content-between align-items-start p-3 mb-2"
                                style={{
                                  backgroundColor: "#F9F9F9",
                                  borderRadius: "8px",
                                }}
                              >
                                <div>
                                  <p
                                    className="mb-1"
                                    style={{
                                      fontSize: "14px",
                                      color: "#333",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {group?.groupName}
                                  </p>
                                </div>
                                <div className="d-flex gap-2">
                                  <button
                                    onClick={() =>
                                      handleOpenEditGroupModal(group)
                                    }
                                    type="button"
                                    style={{
                                      color: "#666",
                                      border: "none",
                                      background: "none",
                                      cursor: "pointer",
                                      padding: "4px",
                                    }}
                                  >
                                    <FiEdit />
                                  </button>
                                  <button
                                    onClick={() =>
                                      commissionGroupDelte(group?._id)
                                    }
                                    type="button"
                                    style={{
                                      color: "#DC3545",
                                      border: "none",
                                      background: "none",
                                      cursor: "pointer",
                                      padding: "4px",
                                    }}
                                  >
                                    <RiDeleteBin5Line />
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <label
                          className="form-label"
                          style={{
                            fontSize: "14px",
                            color: "#555",
                            fontWeight: "500",
                          }}
                        >
                          Select Team Member{" "}
                          <span style={{ color: "#DC3545" }}>*</span>
                        </label>
                        <select
                          value={formData.staffId || ""}
                          name="staffId"
                          onChange={handleChange}
                          className="form-select"
                          style={{
                            borderColor: "#DDD",
                            borderRadius: "8px",
                            padding: "10px 14px",
                            fontSize: "14px",
                          }}
                        >
                          <option value="">Select a team member</option>
                          {teamMember.map((member) => (
                            <option key={member._id} value={member._id}>
                              {member.name}
                            </option>
                          ))}
                        </select>
                        {error.staffId && (
                          <p className="text-danger mt-1 small">
                            {error.staffId}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Commission Model Section */}
                <div
                  className="card mb-4"
                  style={{
                    border: "none",
                    borderRadius: "12px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  }}
                >
                  <div className="card-body p-4">
                    <div className="d-flex align-items-center mb-4 gap-1">
                      <LuTarget color="#EA8F80" />
                      <h5
                        className="mb-0"
                        style={{
                          color: "#333",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Commission Model
                      </h5>
                    </div>

                    {/* Model Type */}
                    <div className="mb-3">
                      <label
                        className="form-label"
                        style={{
                          fontSize: "14px",
                          color: "#555",
                          fontWeight: "500",
                        }}
                      >
                        Model Type
                      </label>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <button
                            onClick={() => handleModelType("TARGET_BASED")}
                            className="w-100 py-3"
                            style={{
                              border:
                                formData.modelType === "TARGET_BASED"
                                  ? "2px solid #EA8F80"
                                  : "2px solid #E0E0E0",
                              backgroundColor:
                                formData.modelType === "TARGET_BASED"
                                  ? "#FFF5F0"
                                  : "#FFF",
                              color:
                                formData.modelType === "TARGET_BASED"
                                  ? "#EA8F80"
                                  : "#666",
                              borderRadius: "8px",
                              cursor: "pointer",
                              transition: "all 0.2s",
                            }}
                          >
                            <LuTarget />
                            <div
                              style={{ fontSize: "14px", fontWeight: "500" }}
                            >
                              Target Based
                            </div>
                          </button>
                        </div>
                        <div className="col-md-6">
                          <button
                            onClick={() => handleModelType("ITEM_BASED")}
                            className="w-100 py-3"
                            style={{
                              border:
                                formData.modelType === "ITEM_BASED"
                                  ? "2px solid #EA8F80"
                                  : "2px solid #E0E0E0",
                              backgroundColor:
                                formData.modelType === "ITEM_BASED"
                                  ? "#FFF5F0"
                                  : "#FFF",
                              color:
                                formData.modelType === "ITEM_BASED"
                                  ? "#EA8F80"
                                  : "#666",
                              borderRadius: "8px",
                              cursor: "pointer",
                              transition: "all 0.2s",
                            }}
                          >
                            <FiPackage />
                            <div
                              style={{ fontSize: "14px", fontWeight: "500" }}
                            >
                              Item Based
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Target Type and Tiers - Only show for Target Based */}
                    {formData.modelType === "TARGET_BASED" ? (
                      <>
                        <div className="mb-3">
                          <label
                            className="form-label"
                            style={{
                              fontSize: "14px",
                              color: "#555",
                              fontWeight: "500",
                            }}
                          >
                            Target Type
                          </label>
                          <select
                            value={formData.targetType}
                            name="targetType"
                            onChange={handleChange}
                            className="form-select"
                            style={{
                              borderColor: "#DDD",
                              borderRadius: "8px",
                              padding: "10px 14px",
                              fontSize: "14px",
                            }}
                          >
                            <option value="MONTHLY">Monthly Target</option>
                            <option value="DAILY">Daily Target</option>
                            <option value="WEEKLY">Weekly Target</option>
                            <option value="VOLUME">Volume Based</option>
                          </select>
                        </div>

                        {/* Commission Tiers */}
                        <div>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <label
                              className="form-label mb-0"
                              style={{
                                fontSize: "14px",
                                color: "#555",
                                fontWeight: "500",
                              }}
                            >
                              Commission Tiers
                            </label>
                            <button
                              type="button"
                              onClick={handleAddTier}
                              style={{
                                color: "#EA8F80",
                                fontSize: "14px",
                                border: "none",
                                background: "none",
                                cursor: "pointer",
                                fontWeight: "500",
                              }}
                            >
                              + Add Tier
                            </button>
                          </div>

                          {/* Tiers */}
                          <div className="space-y-3">
                            {formData.tiers?.map((tier) => (
                              <div
                                key={tier.id}
                                className="p-3 mb-3"
                                style={{
                                  border: "1px solid #E0E0E0",
                                  borderRadius: "8px",
                                  backgroundColor: "#FAFAFA",
                                }}
                              >
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <input
                                    type="text"
                                    value={tier.tierName}
                                    onChange={(e) =>
                                      handleTierChange(
                                        tier.id,
                                        "tierName",
                                        e.target.value
                                      )
                                    }
                                    className="form-control"
                                    style={{
                                      width: "auto",
                                      borderColor: "#DDD",
                                      borderRadius: "6px",
                                      padding: "6px 12px",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    }}
                                  />
                                  {formData.tiers?.length > 1 && (
                                    <button
                                      type="button"
                                      onClick={() => handleRemoveTier(tier.id)}
                                      style={{
                                        color: "#DC3545",
                                        border: "none",
                                        background: "none",
                                        cursor: "pointer",
                                        padding: "4px",
                                      }}
                                    >
                                      <RiDeleteBin5Line />
                                    </button>
                                  )}
                                </div>

                                <div className="row g-3 mb-3">
                                  <div className="col-md-6">
                                    <label
                                      className="form-label"
                                      style={{
                                        fontSize: "12px",
                                        color: "#666",
                                      }}
                                    >
                                      Target From
                                    </label>
                                    <div className="input-group">
                                      <span
                                        className="input-group-text"
                                        style={{
                                          backgroundColor: "#FFF",
                                          borderColor: "#DDD",
                                          color: "#666",
                                        }}
                                      >
                                        {currencySymbol}
                                      </span>
                                      <input
                                        type="number"
                                        min='0'
                                        value={tier.targetFrom ?? 0}
                                         onKeyDown={allowOnlyNumberAndDot}
                                        onChange={(e) =>
                                          handleTierChange(
                                            tier.id,
                                            "targetFrom",
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        style={{
                                          borderColor: "#DDD",
                                          fontSize: "14px",
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <label
                                      className="form-label"
                                      style={{
                                        fontSize: "12px",
                                        color: "#666",
                                      }}
                                    >
                                      Target To
                                    </label>
                                    <div className="input-group">
                                      <span
                                        className="input-group-text"
                                        style={{
                                          backgroundColor: "#FFF",
                                          borderColor: "#DDD",
                                          color: "#666",
                                        }}
                                      >
                                        {currencySymbol}
                                      </span>
                                      <input
                                        type="number"
                                        min='0'
                                        value={tier.targetTo ?? 0}
                                         onKeyDown={allowOnlyNumberAndDot}
                                        onChange={(e) =>
                                          handleTierChange(
                                            tier.id,
                                            "targetTo",
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        style={{
                                          borderColor: "#DDD",
                                          fontSize: "14px",
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="row g-3">
                                  <div className="col-md-6">
                                    <label
                                      className="form-label"
                                      style={{
                                        fontSize: "12px",
                                        color: "#666",
                                      }}
                                    >
                                      Commission Type
                                    </label>
                                    <select
                                      value={tier.commissionType}
                                      onChange={(e) =>
                                        handleTierChange(
                                          tier.id,
                                          "commissionType",
                                          e.target.value
                                        )
                                      }
                                      className="form-select"
                                      style={{
                                        borderColor: "#DDD",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <option value="PERCENT">
                                        Percentage
                                      </option>
                                      <option value="FLAT">Flat</option>
                                    </select>
                                  </div>
                                  <div className="col-md-6">
                                    <label
                                      className="form-label"
                                      style={{
                                        fontSize: "12px",
                                        color: "#666",
                                      }}
                                    >
                                      Commission Value
                                    </label>
                                    <div className="input-group">
                                      {tier.commissionType === "FLAT" && (
                                        <span
                                          className="input-group-text"
                                          style={{
                                            backgroundColor: "#FFF",
                                            borderColor: "#DDD",
                                            color: "#666",
                                          }}
                                        >
                                          {currencySymbol}
                                        </span>
                                      )}
                                      <input
                                        type="number"
                                        min='0'
                                        value={tier.commissionValue ?? 0}
                                         onKeyDown={allowOnlyNumberAndDot}
                                        onChange={(e) =>
                                          handleTierChange(
                                            tier.id,
                                            "commissionValue",
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        style={{
                                          borderColor: "#DDD",
                                          fontSize: "14px",
                                        }}
                                      />
                                      {tier.commissionType === "PERCENT" && (
                                        <span
                                          className="input-group-text"
                                          style={{
                                            backgroundColor: "#FFF",
                                            borderColor: "#DDD",
                                            color: "#666",
                                          }}
                                        >
                                          %
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    ) : (
                      /* Item Based Commissions */
                      <div>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <label
                            className="form-label mb-0"
                            style={{
                              fontSize: "14px",
                              color: "#555",
                              fontWeight: "500",
                            }}
                          >
                            Item Commissions
                          </label>
                          <button
                            type="button"
                            onClick={handleAddItem}
                            style={{
                              color: "#EA8F80",
                              fontSize: "14px",
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                              fontWeight: "500",
                            }}
                          >
                            + Add Item
                          </button>
                        </div>

                        {/* Item Commissions List */}
                        <div className="space-y-3">
                          {formData.items?.map((item) => (
                            <div
                              key={item.id}
                              className="p-3 mb-3"
                              style={{
                                border: "1px solid #E0E0E0",
                                borderRadius: "8px",
                                backgroundColor: "#FAFAFA",
                              }}
                            >
                              <div className="d-flex align-items-center gap-2 mb-3">
                                <div className="flex-grow-1">
                                  <label className="form-label">
                                    Service <span className="text-danger">*</span>
                                  </label>

                                  <Autocomplete
                                    fullWidth
                                    options={serviceList}
                                    value={
                                      serviceList.find(
                                        (s) => s._id === item.itemId
                                      ) || null
                                    }
                                    // onChange={(e, value) =>
                                    //   handleItemChange(
                                    //     item.id,
                                    //     "itemId",
                                    //     value?._id || ""
                                    //   )
                                    // }
                                                                            onChange={(e, value) => {
      handleItemChange(item.id, "itemId", value?._id || "");

      // Clear item error on change
      setError((prev) => {
        if (!prev.items?.[item.id]) return prev;
        const updated = { ...prev };
        delete updated.items[item.id];
        if (Object.keys(updated.items).length === 0) {
          delete updated.items;
        }
        return updated;
      });
    }}
                                    getOptionLabel={(option) => option.name}
                                    isOptionEqualToValue={(opt, val) =>
                                      opt._id === val._id
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select service"
                                        size="small"
                                      />
                                    )}
                                  />
                                                                      {error?.items?.[item.id] && (
    <p className="text-danger mt-1 small">
      {error.items[item.id]}
    </p>
  )}
                                </div>
                                {formData.items?.length > 1 && (
                                  <button
                                    type="button"
                                    onClick={() => handleRemoveItem(item.id)}
                                    style={{
                                      color: "#DC3545",
                                      border: "none",
                                      background: "none",
                                      cursor: "pointer",
                                      padding: "4px",
                                    }}
                                  >
                                    <RiDeleteBin5Line />
                                  </button>
                                )}
                              </div>
                              <div className="row g-3">
                                <div className="col-md-4">
                                  <label
                                    className="form-label"
                                    style={{ fontSize: "12px", color: "#666" }}
                                  >
                                    Item Type
                                  </label>
                                  <select
                                    value={item.itemType}
                                    onChange={(e) =>
                                      handleItemChange(
                                        item.id,
                                        "itemType",
                                        e.target.value
                                      )
                                    }
                                    className="form-select"
                                    style={{
                                      borderColor: "#DDD",
                                      fontSize: "14px",
                                    }}
                                  >
                                    <option value="services">Service</option>
                                    <option value="products">Product</option>
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label
                                    className="form-label"
                                    style={{ fontSize: "12px", color: "#666" }}
                                  >
                                    Commission Type
                                  </label>
                                  <select
                                    value={item.commissionType}
                                    onChange={(e) =>
                                      handleItemChange(
                                        item.id,
                                        "commissionType",
                                        e.target.value
                                      )
                                    }
                                    className="form-select"
                                    style={{
                                      borderColor: "#DDD",
                                      fontSize: "14px",
                                    }}
                                  >
                                    <option value="PERCENT">
                                      Percentage
                                    </option>
                                    <option value="FLAT">Flat</option>
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label
                                    className="form-label"
                                    style={{ fontSize: "12px", color: "#666" }}
                                  >
                                    Commission Value
                                  </label>
                                  <div className="input-group">
                                    {item.commissionType === "FLAT" && (
                                      <span
                                        className="input-group-text"
                                        style={{
                                          backgroundColor: "#FFF",
                                          borderColor: "#DDD",
                                          color: "#666",
                                        }}
                                      >
                                        {currencySymbol}
                                      </span>
                                    )}
                                    <input
                                      type="number"
                                      min='0'
                                      value={item.commissionValue}
                                      onKeyDown={allowOnlyNumberAndDot}
                                      onChange={(e) =>
                                        handleItemChange(
                                          item.id,
                                          "commissionValue",
                                          e.target.value
                                        )
                                      }
                                      className="form-control"
                                      style={{
                                        borderColor: "#DDD",
                                        fontSize: "14px",
                                      }}
                                    />
                                    {item.commissionType === "PERCENT" && (
                                      <span
                                        className="input-group-text"
                                        style={{
                                          backgroundColor: "#FFF",
                                          borderColor: "#DDD",
                                          color: "#666",
                                        }}
                                      >
                                        %
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="d-flex justify-content-end gap-3 mb-5">
                  <button
                    onClick={() => navigate(-1)}
                    className="btn btn-outline-secondary px-4 py-2"
                    style={{
                      borderColor: "#DDD",
                      color: "#666",
                      borderRadius: "8px",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleUpdate}
                    className="btn px-4 py-2"
                    style={{
                      background: "linear-gradient(to right, #EA8F80, #F09A8B)",
                      color: "#FFF",
                      border: "none",
                      borderRadius: "8px",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    Update Structure
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal
        centered
        size="md"
        show={groupModal}
        onHide={handleCloseGroupModal}
      >
        <Modal.Header>
          <Modal.Title style={{ fontSize: 16, fontWeight: 600 }}>
            {groupMode === "ADD" ? "Create New Group" : "Update Group"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Group Name */}
          <div className="mb-3">
            <label
              className="form-label"
              style={{ fontSize: "14px", fontWeight: 500, color: "#444" }}
            >
              Group Name
            </label>

            <input
              type="text"
              className="form-control"
              placeholder="e.g., Senior Stylists"
              onChange={handleGrpupChange}
              value={groupForm.groupName}
              name="groupName"
              style={{
                borderRadius: "8px",
                padding: "10px 14px",
                fontSize: "14px",
              }}
            />
          </div>

          {/* Team Members */}
          <div className="mb-2">
            <label
              className="form-label"
              style={{ fontSize: "14px", fontWeight: 500, color: "#444" }}
            >
              Select Team Members
            </label>

            <div
              style={{
                border: "1px solid #E0E0E0",
                borderRadius: "8px",
                padding: "10px",
                maxHeight: "220px",
                overflowY: "auto",
              }}
            >
              {teamMember.map((member) => (
                <div key={member._id} className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`member-${member._id}`}
                    checked={groupForm.staffId.includes(member._id)}
                    onChange={(e) => handleStaffToggle(e, member._id)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`member-${member._id}`}
                    style={{ fontSize: "14px", color: "#333" }}
                  >
                    {member.name}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="outlined" onClick={handleCloseGroupModal}>
            Cancel
          </Button>
          <Button
            onClick={handleGroupSubmit}
            style={{
              background: "#ff6a00",
              borderColor: "#ff6a00",
              padding: "6px 18px",
              color: "#fff",
              marginLeft: "10px",
            }}
          >
            {groupMode === "ADD" ? "Create Group" : "Update Group"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UpdateCommissionStructure;